import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import '../Login//Login.css'
import * as Constants from '../../constants';
import UsuarioService from '../../services/usuario.service';

const ResetPassword = (props) => {
	const [email, setEmail] = useState('')
	const [emailError, setEmailError] = useState('')

	const [t, i18n] = useTranslation("global");

	const toastOkSendEmailResetPwd = () => toast.success(t('app.mensaje.sendEmailResetPasswordOK'));
	const toastErrorSendEmailResetPwd = () => toast.error(t('app.error.sendEmailResetPassword'));
	const toastGenericError = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {

		const userBrowserLang = getUserBrowserLanguage();

		i18n.changeLanguage(userBrowserLang);
	}, [i18n]);

	const getUserBrowserLanguage = () => {
		const lang = window.navigator.language;

		if (lang.includes("es")) return "es";
		if (lang.includes("ca")) return "ca";
		if (lang.includes("en")) return "en";

		return "en";
	};

	const onButtonClick = (e) => {
		e.preventDefault();

		// Set initial error values to empty  
		setEmailError('')

		// Check if the user has entered the email correctly  	
		if ('' === email) {
			setEmailError(t('app.error.login.email'))
			return
		}

		if (!checkEmailFormat(email)) {
			setEmailError(t('app.error.login.emailFormat'))
			return
		}

		restablecerPassword(email);
	}

	const restablecerPassword = async (email) => {
		const toastLoading = toast.loading(t('app.mensaje.loading'));

		await UsuarioService.obtenerTokenPwd(email)
			.then((response) => {

				if (response.status === 200) {
					toast.dismiss(toastLoading);

					toastOkSendEmailResetPwd();
				} else {
					toast.dismiss(toastLoading);
					
					toastErrorSendEmailResetPwd();
				}
			})
			.catch((err) => {
				toast.dismiss(toastLoading);

				toastGenericError();
			});
	}

	function checkEmailFormat(email) {
		const isValidEmail = Constants.emailRegex;

		if (isValidEmail.test(email)) {
			return true;
		} else {
			return false;
		}
	}

	return (
		<div className="login-container">
			<div className="login-image">
				<img src={require("../../assets/img/portada.png")} alt="Login Image" />
			</div>
			<div className="login-form">
				<div className="login-logo">
					<img src={require("../../assets/img/logo.png")} alt="Login Logo" />
				</div>
				<form onSubmit={onButtonClick}>
					<div className={'inputContainerLogin'}>
						<label className={'inputResetPasswordLabel'}>{t('app.login.inputResetPassword')}</label>
						<input
							value={email}
							placeholder={t('app.login.email')}
							onChange={(ev) => setEmail(ev.target.value)}
							className={'inputBox'}
						/>
						<label className="errorLabel">{emailError}</label>
					</div>
					<br />
					<div className={'inputContainerLogin'}>
						<input className={'inputButtonLogin'} type="submit" value={t("app.login.enviar")} />
						<Toaster />
					</div>
				</form>
			</div>
		</div>
	)
}

export default ResetPassword